import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useUpdateTransfer({ id }) {
  const queryClient = useQueryClient()

  const action = async ({
    date,
    description = '',
    amount,
    recurring_settings,
    modelId,
    vaultFrom,
    vaultTo,
    update_all,
  }) => {
    const response = await httpClient.put(`/team/cash-flow/transfers/${id}`, {
      transaction_date: date,
      description,
      amount,
      recurring_settings,
      what_if_id: modelId,
      vault_from: vaultFrom,
      vault_to: vaultTo,
      update_all,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
      queryClient.invalidateQueries({
        queryKey: ['transaction-repeat-options'],
      })
      queryClient.invalidateQueries({ queryKey: ['todo-count'] })
      queryClient.invalidateQueries({ queryKey: ['todos', 'list'] })

      toast.success('Transfer successfully updated.')
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
